import { tv } from 'tailwind-variants'

export const headerStyles = tv({
	base: 'web:scroll-m-20 text-foreground tracking-tight web:select-text text-palette_3 font-apercu-primary',
	variants: {
		variant: {
			hxl: 'lg:text-6xl text-5xl font-apercu-bold',
			h1: 'lg:text-5xl text-[2.5rem] font-apercu-bold',
			h2: 'text-3xl font-apercu-bold',
			h3: 'text-2xl font-apercu-bold',
			h4: 'text-xl font-apercu-bold',
			h5: 'text-base',
		},
	},
})
